import { CoreEnrollment, Enrollment } from "../../../@types/enrollment.types";
import { Member } from "../../../@types/member.types";
import { Paycheck } from "../../../@types/paycheck.types";
import { Theme } from "../../../@types/theme.types";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { request } from "../api";

const initialRoute = "pages";
const { get } = request;

export type AdminEnrollmentInitDataQuery = {
	insured_SSN: string;
	plan_code: string;
	group_number: number;
	enrollment_status?: "ACTIVE";
	plan_name?: string;
};

export const getAdminEnrollmentInitData = async (
	query: AdminEnrollmentInitDataQuery
): Promise<{
	theme: Theme;
	enrollments: CoreEnrollment[];
	dependents: Member[];
	paycheck: Paycheck;
	currentActivePlanDetails?: any;
}> => {
	try {
		const endpoint = `${initialRoute}/admin-enrollment-init`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			query
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;

				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		//alert(err);
		throw err;
	}
};

export const enrollmentInit = {
	getAdminEnrollmentInitData
};
